var map = {
	"./de.json": 352802,
	"./en_GB.json": 853302,
	"./es.json": 893369,
	"./fr.json": 658081,
	"./it.json": 223116,
	"./ja.json": 463272,
	"./ko.json": 173315,
	"./nl.json": 405387,
	"./pl.json": 228233,
	"./pt_BR.json": 699446,
	"./ru.json": 674620,
	"./zh.json": 82083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540646;